export default {
  'SET_FILTERS'(state, data) {
    state.filters = data;
  },
  'SET_TIME_FRAMES'(state, data) {
    state.timeFrames = data;
  },
  'SET_SELECTED_TIME_FRAME'(state, timeFrameId) {
    state.filters = {
      ...state.filters,
      timeFrameId: timeFrameId
    };
  },
  'SET_EVENTS'(state, data) {
    state.events = data;
  },
  'SET_COMMAND_LOG'(state, data) {
    state.commandLog = data;
  }
};